const counters = document.querySelectorAll('.counter');
    const counterSection = document.querySelector('.counter-section');

    const animateCounters = () => {
      counters.forEach(counter => {
        const target = +counter.getAttribute('data-target');
        const increment = target / 100; // Divide target into 100 steps for smooth animation
        let current = 0;

        const updateCounter = () => {
          current += increment;
          if (current < target) {
            counter.textContent = Math.ceil(current);
            requestAnimationFrame(updateCounter);
          } else {
            counter.textContent = target;
          }
        };

        updateCounter();
      });
    };

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          animateCounters();
          observer.unobserve(counterSection); // Stop observing once animation is triggered
        }
      });
    });

    observer.observe(counterSection);